export default __webpack_public_path__ + "static/media/Screenshot (1123).a4f834e1.png";